/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { TicketEditBaseComponent } from '../ticket-edit-base/ticket-edit-base.component';
import { TicketCounts } from 'src/app/app-data/models/EditTicketsCombined';

@Component({
	selector: 'multi-edit-masthead',
	templateUrl: './multi-edit-masthead.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultiEditMastheadComponent extends TicketEditBaseComponent {
	@Input() public typeCounts: TicketCounts;
	@Input() public currentType: string;
	@Input() public totalTickets: number;
}
